import "./BoyNames.module.css";
import BrandNavigationHeader from "@/reusable_sections/Header";
import BoyNameDirectory from "./sections/BoyNameDirectory";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function BoyNamesPage() {
  return <div>
      <BrandNavigationHeader />
      <BoyNameDirectory />
      <CompanyDirectory />
    </div>;
}